import { FIXES, PAIN_POINTS } from "../../data/landingContent";
import { IconCheck } from "./icons";
import Reveal from "./Reveal";

export default function ProblemSolution() {
  return (
    <section aria-labelledby="problem-heading">
      <div className="wrap split">
        <Reveal>
          <span className="kicker">The problem</span>
          <h2 className="section-title" id="problem-heading">
            Most Indian clinics run on <b>disconnected tools</b>
          </h2>
          <div className="pain-list">
            {PAIN_POINTS.map((p) => (
              <div className="pain-item" key={p.title}>
                <span className="x" aria-hidden="true">✕</span>
                <p>
                  <strong>{p.title}</strong> {p.detail}
                </p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal className="fix-panel">
          <span className="kicker">The fix</span>
          <h2 className="section-title" style={{ fontSize: "clamp(24px, 2.6vw, 34px)" }}>
            One platform, <b>built for clinics</b>
          </h2>
          <div className="fix-list">
            {FIXES.map((f) => (
              <div className="fix-item" key={f.title}>
                <span className="check" aria-hidden="true"><IconCheck /></span>
                <div>
                  <h3>{f.title}</h3>
                  <p>{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
